import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Question extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/questionnaire/question'
    super(store, path)
  }
}
